/**
 * 휴대폰 번호가 010으로 시작하는지, 11자리 숫자로만 이루어졌는지 확인합니다.
 */
export const isValidPhoneKR = (phoneNumber: string) => {
  return /^010\d{8}$/.test(phoneNumber);
};

export const isSixshopProUser = (email?: string | null) => {
  return email?.split("@").pop()?.includes("sixshop-pro.com") ?? false;
};
